<template>
  <div>
    <aboutcontent></aboutcontent>
  </div>
</template>

<script>
import aboutcontent from "@/components/contentcoms/aboutcontentcoms/aboutcontent";
export default {
    name: "about",
    components: {aboutcontent}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/about.vue